import * as Demo from "@/api/modules/java/demo"; // 公共接口
import * as indexPage from "@/api/modules/java/indexpage"; // 首页接口
import * as accountOpen from "@/api/modules/java/account.open"; // 开户管理
import * as commen from "@/api/modules/java/commen"; // 开户管理
import * as authorizeList from "@/api/modules/java/authorizeList"; //授权
import * as accountDoApply from "@/api/modules/java/accountDoApply"; //账户操作
import * as mediaPlatform from "@/api/modules/java/mediaPlatform"; //媒体平台
import * as accountInfo from "@/api/modules/java/accountInfo"; //充值管理
import * as policy from "@/api/modules/java/policy"; // 封户、拒登
import alm from './modules/java/alm'; // meta alm
import airwallex from './modules/java/airwallex';
import * as metaRegister from './modules/java/meta.register';

let all = {
  ...Demo,
  ...indexPage,
  ...accountOpen,
  ...commen,
  ...authorizeList,
  ...accountDoApply,
  ...mediaPlatform,
  ...accountInfo,
  ...policy,
  ...alm,
  ...airwallex,
  ...metaRegister,
};
export default all;
